import type { IconData } from '@stacksjs/iconify-core'

export const contentMute: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7.5 0L4.25 3.25L1 0L0 1l15 15l1-1l-2.05-2.05A7 7 0 0 0 9 1v2.5a4.5 4.5 0 0 1 3.182 7.682l-1.06-1.06A3 3 0 0 0 9 5v2.999L7.499 6.5zm0 10.5L1 4H0v8h3.5l4 4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentMute
